import React from "react";
import { Button } from "aible";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import AccountSelector from "containers/Accounts/AccountSelector";

import AWSIcon from "images/EDG/DB/AWS.svg";
import AzureIcon from "images/EDG/DB/AZURE.svg";
import GCPIcon from "images/gcp.svg";

import styles from "./style.module.css";
import { JsonFileInput } from "components/SchemaMonitor/SchemaMonitor";
import { Dialog, DialogContent, DialogFooter } from "@/aible/Dialog/Dialog";

// Difference from the one in SchemaMonitor reducer
export const DATA_SOURCES = [
  {
    value: "gcs",
    label: "Google Cloud Storage",
    image: GCPIcon,
    settings: [
      { label: "Dataset Name", value: "name", default: "New Dataset" },
      { label: "Bucket", value: "bucket" },
      { label: "Object", value: "object" },
      { label: "Upload Credentials JSON", value: "credentials", isJsonUpload: true }
    ]
  },
  {
    value: "s3",
    label: "AWS S3",
    image: AWSIcon,
    settings: [
      { label: "Dataset Name", value: "name", default: "New Dataset" },
      { label: "Bucket", value: "bucket" },
      { label: "Key", value: "key" },
      { label: "Access Key Id", value: "awsAccessKeyId" },
      { label: "Secret Access Key", value: "awsSecretAccessKey", isPassword: true },
      { label: "Session Token (Optional)", value: "awsSessionToken", isPassword: true }
    ]
  },
  {
    value: "azureBlobStore",
    label: "Azure Blob Storage",
    image: AzureIcon,
    settings: [
      { label: "Dataset Name", value: "name", default: "New Dataset" },
      { label: "Container", value: "container" },
      { label: "Key", value: "key" },
      { label: "Storage Account", value: "storageAccount" },
      { label: "Access Key", value: "accessKey", isPassword: true }
    ]
  }
];

const DEFAULT_STATE = {
  isLinkModal: undefined,
  isMockedTable: false,
  settings: {}
};
export default class DatasetLink extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLinkModal: undefined,
      isMockedTable: false,
      settings: {},
      catalog: {}
    };
  }

  resetState() {
    this.setState({
      ...DEFAULT_STATE,
      settings: {}
    });
  }

  updateSetting(key, value) {
    const { settings } = this.state;
    const retSettings = {
      ...settings,
      [key]: value
    };
    this.setState({ settings: retSettings });
  }

  initSettings(source) {
    const retSettings = {};
    if (source) {
      retSettings.type = source.value;
      source.settings &&
        source.settings.forEach((setting) => {
          retSettings[setting.value] = setting.default !== undefined ? setting.default : undefined;
        });
    }
    this.setState({ isLinkModal: source, settings: retSettings });
  }

  renderIsMockedTable() {
    const mockInfo = {
      DatabaseType: "Postgres",
      Tables: [
        {
          Name: "Solar Sales Clean",
          RowCount: 31300,
          Columns: [
            {
              Name: "age",
              Type: "INT"
            },
            {
              Name: "age",
              Type: "INT"
            },
            {
              Name: "age",
              Type: "INT"
            },
            {
              Name: "age",
              Type: "INT"
            },
            {
              Name: "age",
              Type: "INT"
            },
            {
              Name: "job_title",
              Type: "VARCHAR(64)"
            },
            {
              Name: "marital_status",
              Type: "VARCHAR(64)"
            },
            {
              Name: "contact_type",
              Type: "VARCHAR(64)"
            },
            {
              Name: "contact_month",
              Type: "VARCHAR(64)"
            },
            {
              Name: "term_deposit_conversion",
              Type: "VARCHAR(64)"
            }
          ]
        },
        {
          Name: "SalesOptimization",
          RowCount: 50000,
          Columns: [
            {
              Name: "account_id",
              Type: "INT"
            },
            {
              Name: "stage_name",
              Type: "VARCHAR(64)"
            },
            {
              Name: "amount",
              Type: "INT"
            },
            {
              Name: "lead_source",
              Type: "VARCHAR(64)"
            },
            {
              Name: "is_won",
              Type: "BOOL"
            }
          ]
        }
      ]
    };

    const smallColumnStyle = {
      minWidth: "80px",
      maxWidth: "80px"
    };

    return (
      <div className={styles.datasetTable}>
        <div className={styles.boldItem} style={{ padding: "20px", paddingTop: "0px" }}>
          {mockInfo && mockInfo.Tables ? mockInfo.Tables.length + " tables found" : ""}
        </div>
        <div className={styles.gTable}>
          <div className={styles.gTableHeader}>
            <div className={styles.gTableColLink} style={smallColumnStyle}>
              {"Catalog"}
            </div>
            <div className={styles.gTableColLink} style={smallColumnStyle}>
              {"Explore"}
            </div>
            <div className={styles.gTableColLink}>{"Table Name"}</div>
            <div className={styles.gTableColLink}>{"Columns"}</div>
            <div className={styles.gTableColLink}>{"Rows"}</div>
          </div>
          <div className={styles.gTableBody}>
            {mockInfo &&
              mockInfo.Tables &&
              mockInfo.Tables.map((d, i) => (
                <div className={styles.gTableRow} key={i}>
                  <div className={styles.gTableColLink} style={smallColumnStyle}>
                    <input
                      type="checkbox"
                      ref="cb1"
                      onChange={() => this.setState({ canAdvance: true })}
                      checked={this.state.catalog[d.Name] === true}
                    />
                  </div>
                  <div className={styles.gTableColLink} style={smallColumnStyle}>
                    <input
                      type="checkbox"
                      ref="cb2"
                      onClick={() =>
                        this.setState({
                          catalog: { ...this.state.catalog, [d.Name]: true }
                        })
                      }
                    />
                  </div>
                  <div className={styles.gTableColLink}>{d.Name}</div>
                  <div className={styles.gTableColLink}>{d.Columns ? Object.keys(d.Columns).length : ""}</div>
                  <div className={styles.gTableColLink}>{d.RowCount}</div>
                </div>
              ))}
          </div>
        </div>
        {this.state.canAdvance && this.state.isTableLoading ? (
          <div style={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
            <div className={styles.loadingFlex}>
              {"Importing..."}
              <LoadingIndicator style={{ margin: "0px" }} />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }

  renderContent() {
    const { linkDataset, handleFileUpload } = this.props;
    const { isMockedTable, isLinkModal, settings } = this.state;

    return isMockedTable ? (
      this.renderIsMockedTable()
    ) : (
      <div className={styles.datasetLink}>
        {isLinkModal !== undefined ? (
          <LinkModal
            title={isLinkModal && isLinkModal.label}
            settingsList={isLinkModal && isLinkModal.settings}
            settings={settings}
            type={isLinkModal && isLinkModal.value}
            onUpload={handleFileUpload}
            onCreate={() => linkDataset(settings)}
            onClose={() => this.setState({ isLinkModal: undefined, settings: {} })}
            onChange={(key, value) => this.updateSetting(key, value)}
            comingSoon={isLinkModal && isLinkModal.comingSoon}
            image={isLinkModal && isLinkModal.image}
          />
        ) : (
          <div className={styles.dCreds}>
            <div className={styles.majorHeader} style={{ marginBottom: "25px", textAlign: "center" }}>
              {"Select Cloud Storage"}
            </div>
            <div className={styles.sources}>
              {DATA_SOURCES.map((source, i) =>
                source.hide ? (
                  ""
                ) : (
                  <div className={styles.dataSource} onClick={() => this.initSettings(source)} key={source.value}>
                    <div className={styles.dataSourceIcon}>
                      <img src={source.image} />
                    </div>
                    <div className={styles.dataSourceName}>{source.label}</div>
                  </div>
                )
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  handleTabUpload() {
    const { handleTableauUpload } = this.props;
    if (this.state.tableau !== undefined && this.state.tableau.value !== undefined) {
      handleTableauUpload(this.state.tableau.value);
      this.setState({ tableau: -1 });
    }
  }

  handleLink(e) {
    const { linkDataset } = this.props;
    const { isLinkModal, settings } = this.state;
    if (isLinkModal) {
      switch (isLinkModal.value) {
        case "csv":
          document.getElementById("dLink-fUpload").click();
          break;
        default:
          this.setState({ isLinking: true });

          linkDataset({
            uploadName: "credentials.json",
            ...settings
          })
            .then(() => {
              this.handleHide();
              this.setState({ isLinking: false });
            })
            .catch(() => {
              this.handleHide();
              this.setState({ isLinking: false });
            });
          return;
      }
      this.handleHide();
    }
  }

  handleHide() {
    const { updateIsLinkMode } = this.props;
    updateIsLinkMode(false);
    this.setState({ isMockedTable: false });
    return this.resetState();
  }

  render() {
    const { isLinkMode, updateIsLinkMode, addMockCatalog, handleFileUpload } = this.props;

    const { isLinkModal, isMockedTable, canAdvance, isTableLoading, isLinking } = this.state;

    return (
      <Dialog open={isLinkMode} onOpenChange={() => this.handleHide()}>
        <DialogContent size="lg">
          <div className={styles.linkModal}>{this.renderContent()}</div>
          <div style={{ display: "none" }}>
            <input type="file" ref="file" id="dLink-fUpload" onChange={handleFileUpload} />
          </div>
          <DialogFooter>
            <div>
              <Button type="secondary" onClick={() => this.handleHide()}>
                {"Cancel"}
              </Button>
              {!isTableLoading && (isLinkModal !== undefined || isMockedTable) && (
                <React.Fragment>
                  <Button
                    onClick={() => {
                      return this.setState({
                        isLinkModal: undefined,
                        isMockedTable: false
                      });
                    }}
                    style={{ marginLeft: "auto" }}
                  >
                    {"Back"}
                  </Button>
                  {!isMockedTable ? (
                    <Button
                      type="primary"
                      style={{ marginLeft: "10px" }}
                      disabled={isLinking}
                      onClick={(e) => {
                        this.handleLink(e);
                      }}
                    >
                      {isLinkModal && isLinkModal.value === "csv"
                        ? "Select CSV to Upload"
                        : isLinking
                          ? "Creating Link..."
                          : "Link Dataset"}
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      style={{ marginLeft: "10px" }}
                      onClick={() => {
                        addMockCatalog();
                        this.setState({ isTableLoading: true });

                        setTimeout(() => {
                          updateIsLinkMode(false);
                          this.setState({ isTableLoading: false });
                        }, 3000);
                      }}
                      disabled={!canAdvance}
                    >
                      {"Import Selected Data"}
                    </Button>
                  )}
                </React.Fragment>
              )}
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

export class LinkModal extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const { title, settings, settingsList, onChange, comingSoon, image } = this.props;

    if (comingSoon) {
      return (
        <div className={styles.dCreds} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div className={styles.majorHeader} style={{ marginBottom: "50px", textAlign: "center" }}>
            {title}
          </div>
          <div className={styles.dataSourceIcon}>
            <img src={image} />
          </div>
          <div>{"Coming Soon"}</div>
        </div>
      );
    }

    return (
      <div className={styles.dCreds}>
        <div className={styles.majorHeader} style={{ marginBottom: "25px", textAlign: "center" }}>
          {title}
        </div>
        <div className={styles.sourceLabel}>
          <span style={{ minWidth: "100px", marginRight: "10px" }}>{"Store Data in: "}</span>
          <AccountSelector />
        </div>
        {settingsList.map((s, i) =>
          s.isJsonUpload ? (
            <div style={{ marginLeft: "185px", marginTop: "10px" }}>
              <JsonFileInput
                key={"setting-input" + s.value}
                label={s.label}
                onChange={(fileText) => onChange([s.value], JSON.parse(fileText))}
              />
            </div>
          ) : (
            <LineInput
              key={i}
              isMediumBox
              value={settings[s.value]}
              onChange={(val) => onChange([s.value], val)}
              label={s.label}
              labelStyle={{ width: "175px", textAlign: "right", flexShrink: "0" }}
              isPassword={s.isPassword}
            />
          )
        )}
      </div>
    );
  }
}
